exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".game-player-score-before .label[data-v-7eedeef8]{font-size:3vw;display:block;text-align:center;background-color:var(--full)}#game .game2022 .game-player-score-before[data-v-7eedeef8]{background-color:var(--red-highlight);color:var(--white);margin-bottom:1vw;opacity:1}", ""]);

// exports
